import { ref } from 'vue';

export const scrollDisabled = ref(false);